export const STUDENT_SENSITIVE_STATUS_FILTERS = [
  'active',
  'ended',
] as const;

export type StudentSensitiveStatusFilter = (typeof STUDENT_SENSITIVE_STATUS_FILTERS)[number];

export const STUDENT_SENSITIVE_STATUS_FILTER_LABELS: Record<StudentSensitiveStatusFilter, string> = {
  active: 'Sensível',
  ended: 'Encerrada',
};

export const STUDENT_SENSITIVE_STATUS_FILTER_OPTIONS = STUDENT_SENSITIVE_STATUS_FILTERS.map((value) => ({
  value,
  label: STUDENT_SENSITIVE_STATUS_FILTER_LABELS[value],
}));
